/*
  ~== TODO ==~
      [ ] - implement layout (portraits and landscape) for reports in api
      [ ] - should prob be api based, going to bloat application, especially if we start to embed assets
      [ ] - data source up to report level?
*/

import renderRatingComparison from './reportTemplates/renderRatingComparison'
import renderListingsComparison from './reportTemplates/renderListingsComparison'

const genericDataParsingFunction = `
return data[0].results.map(function(result) {
  var compiled = {}; 
  data[0].columns.map(function(col, index) {
    compiled[col.name] = result[index];
  });
  return compiled;
})
`;

export default {
  reports: [
    {
      name: "Blank Report",
      description: " ",
      dependencies: ['highcharts'],
      components: [[{}]], // one row, one column, blank component
    },
    {
      name: "Review Summary Report",
      description: 'Shows key review stats across all locations',
      handlebars: require("./reportTemplates/reviewSummaryReport.hbs"),
      thumbnail: 'https://pdf-report-dl-link.s3.amazonaws.com/ddf354219aac374f1d40b7e760ee5bb7-6fa133a01214e88a595fcad645faf7.png',
      layout: "Portrait",
      enabled: true,
      dependencies: ['highcharts'],
      components: [
        [{
          id: "A",
          componentId: "5c23dab95ba8d829c3c0a876"
        }],
        [
          {
            id: "B1",
            name: 'Review Snapshot',
            componentId: '5c23dab95ba8d829c3c0a87e'
          },
          {
            id: "B2",
            name: "Overall Rating",
            componentId: '5c23dab95ba8d829c3c0a879'
          },
        ],
        [
          {
            id: "C1",
            name: "Response Rate",
            componentId: '5c23dab95ba8d829c3c0a87b'
          },
          {
            id: "C2",
            name: "Review Average by Region",
            componentId: '5c7717c3700fe70bfc5b69a5'
          },
        ]
      ]
    },
    { // need to add this listing presence component
      name: "Listing Progress Report",
      description: "Overall summary of your listing accuracy and presence.",
      handlebars: require('./reportTemplates/listingProgressReport.hbs'),
      thumbnail: "https://pdf-report-dl-link.s3.amazonaws.com/c3daba8ba04565423e12eb8cb6237b46-2c8dc05794029229722056b8a8dd19.png",
      components: [
        [{
          id: "A",
          componentId: "5c23dab95ba8d829c3c0a876"
        }],
        [
          {
            id: "B",
            componentId: "5cb660ad3ed63b13ddfafe71",
            name: "Listing Presence",
          },
          {
            id: "C",
            name: "Missing and Duplicate Listings Over Time",
            componentId: "5c40364c700fe749565a61ea"
          },
        ],
        [
          {
            id: "D",
            componentId: "5c3fe573700fe71271244804",
            name: "Accuracy Over Time",
          },
          {
            id: "E",
            componentId: "5c7ef209700fe76be58af55c",
            name: "LBV Score Breakdown for Listings"
          }
        ],
      ]
    }
  ]
}
